<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon small class="ml-1" :aria-label="$t('inventory.purchase_invoices.row_actions')" :title="$t('inventory.purchase_invoices.row_actions')" v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="$emit('book')">
        <v-list-item-title>{{ $t('inventory.purchase_invoices.book') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="line.bookingStatus !== 'BOOKED'" @click="$emit('set-status', 'BOOKED')">
        <v-list-item-title>{{ $t('inventory.purchase_invoices.mark_booked') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="line.bookingStatus !== 'HANDLED'" @click="$emit('set-status', 'HANDLED')">
        <v-list-item-title>{{ $t('inventory.purchase_invoices.mark_handled') }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="line.bookingStatus !== 'NOT_BOOKED'" @click="$emit('clear-status')">
        <v-list-item-title>{{ $t('inventory.purchase_invoices.clear_status') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
// Ostolaskurivin kirjaustoiminnot; sama valikko työpöydän taulurivillä ja mobiilin laskukortilla.
export default {
  name: 'PurchaseLineMenu',
  props: {
    line: {
      type: Object,
      required: true,
    },
  },
};
</script>
